import { useMemo } from "react";
import { BubbleDataPoint } from "chart.js";
import { map, max } from "lodash";
import { content, darken, transparentize } from "@glossy";
import { GlossyTheme } from "@glossy/theme/types";
import { normalize } from "@tootools/number";
import { BubbleSerie as Serie } from "../models";

const getMaxSizeMetric = (datasets: Serie[]) =>
  max(map(datasets, (dataset) => max(map(dataset.data, "size"))));

const getData = (dataset: Serie, maxSizeMetric: number) =>
  map(dataset.data, (data) => ({
    x: data.x,
    y: data.y,
    r: !data.size ? 8 : normalize([0, 36], 0, maxSizeMetric, data.size),
    value: data.size,
  }));

const getStyles = (color: string, theme: GlossyTheme) => ({
  borderColor: color,
  backgroundColor: transparentize(0.2, color),
  accentColor: color,
  accentFadedColor: content({ theme }, "tertiary"),
  hoverBackgroundColor: darken(0.1, color),
  hoverBorderColor: transparentize(0.8, color),
  hoverBorderWidth: ({
    dataset: { data },
  }: {
    dataset: { data: BubbleDataPoint[] };
  }) => data[0].r + 12,
  hoverRadius: 0,
});
export const useData = (datasets: Serie[], theme: GlossyTheme) =>
  useMemo(() => {
    const maxSizeMetric = getMaxSizeMetric(datasets);
    return map(datasets, (dataset) => {
      return {
        ...dataset,
        data: getData(dataset, maxSizeMetric),
        ...getStyles(dataset.color, theme),
      };
    });
  }, [datasets, theme]);
